module.exports = __webpack_public_path__ + "assets/03e431f79d64168db02ec8bc0e2eae73.png";